/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://h6hn5ali23.execute-api.us-east-1.amazonaws.com/master",
            "region": "us-east-1"
        },
        {
            "name": "BillingAPI",
            "endpoint": "https://jmdjl5jrob.execute-api.us-east-1.amazonaws.com/master",
            "region": "us-east-1"
        },
        {
            "name": "CertificateAPI",
            "endpoint": "https://2p3ru2va2l.execute-api.us-east-1.amazonaws.com/master",
            "region": "us-east-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://4fybpnknyfc2righe6yebwwla4.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-td5ny2wx7zeezjq3ye46i5jciy",
    "aws_cognito_identity_pool_id": "us-east-1:c98c230b-031b-4475-80ef-72f054770e80",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_FyXQDYhO7",
    "aws_user_pools_web_client_id": "7mjv8e0am9a9le91r0ldgklfvd",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "learning-storage103306-master",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
